import { getTrustWalletProvider } from "./connector";

export enum ConnectorNames {
  MetaMask = "metaMask",
  WalletLink = "coinbaseWallet",
  TrustWallet = "trustWallet",
  MetaDap = "metaDap",
}

declare global {
  interface Window {
    coinbaseSolana: any;
  }
}

const isMetamaskInstalled = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (window.ethereum?.isMetaMask) {
    return true;
  }

  if (window.ethereum?.providers?.some((p) => p.isMetaMask)) {
    return true;
  }

  return false;
};

export const wallets = [
  {
    id: "metaMask",
    title: "Metamask",
    logoUrl: "/icons/wallets/metamaskWallet.svg",
    isMobile: true,
    get installed() {
      return isMetamaskInstalled();
    },
    connectorId: ConnectorNames.MetaMask,
    deepLink: `https://metamask.app.link/dapp/${process.env.HOST_WEB_USER}/`,
    downloadLink: `https://metamask.app.link/dapp/${process.env.HOST_WEB_USER}/`,
  },
  {
    id: "coinbase",
    title: "Coinbase Wallet",
    logoUrl: "/icons/wallets/coinbaseWallet.svg",
    connectorId: ConnectorNames.WalletLink,
    downloadLink:
      "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
    get installed() {
      return typeof window !== "undefined" && Boolean(window?.coinbaseSolana);
    },
  },
  {
    id: "metaDap",
    title: "MetaDAP Wallet",
    logoUrl: "/icons/wallets/metaDap.svg",
    isMobile: true,
    get installed() {
      return true;
    },
    connectorId: ConnectorNames.MetaDap,
    deepLink: `https://metamask.app.link/dapp/${process.env.HOST_WEB_USER}/`,
    downloadLink: `https://metamask.app.link/dapp/${process.env.HOST_WEB_USER}/`,
  },
];

export interface IWallet {
  id: string;
  title: string;
  logoUrl: string;
  isMobile: boolean;
  readonly installed: boolean;
  connectorId: ConnectorNames;
  deepLink: string;
  downloadLink: string;
}
